import { render, staticRenderFns } from "./Cargos.vue?vue&type=template&id=22a38128&"
import script from "./Cargos.vue?vue&type=script&lang=js&"
export * from "./Cargos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports